'use client'

import InfoCircle from '@/components/icons/info-circle'
import { trackEvent } from '@/lib/mixpanel'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

export default function ErrorPage({ error }) {
  const router = useRouter()

  useEffect(() => {
    // Log to Vercel (captured by console.error in production)
    console.error('Application Error:', {
      message: error?.message || 'Unknown error',
      digest: error?.digest,
      stack: error?.stack,
      timestamp: new Date().toISOString(),
      userAgent:
        typeof window !== 'undefined' ? window.navigator.userAgent : 'unknown',
      url: typeof window !== 'undefined' ? window.location.href : 'unknown',
    })

    // Track in Mixpanel
    trackEvent('Application Error', {
      error: error?.message || 'Unknown error',
      digest: error?.digest,
      timestamp: new Date().toISOString(),
    })
  }, [error])

  const handleGoHome = () => {
    router.push('/')
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black px-4 py-16">
      <div className="w-full max-w-md text-center">
        {/* Friendly icon */}
        <div className="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-gray-800">
          <InfoCircle className="h-12 w-12 text-gray-400" />
        </div>

        {/* Main message */}
        <h1 className="mb-4 text-2xl font-bold text-white">
          Oops! Something went wrong
        </h1>

        <p className="mb-8 text-gray-300">
          We encountered an unexpected issue, but don&apos;t worry - our team
          has been notified and is looking into it.
        </p>

        {/* Action buttons */}
        <div className="mb-8 flex justify-center">
          <button
            onClick={handleGoHome}
            className="rounded bg-blue-600 px-4 py-2 font-semibold text-white hover:bg-blue-700"
          >
            Go to homepage
          </button>
        </div>

        {/* Support message */}
        <div className="space-y-2 text-sm text-gray-400">
          <p>
            If you continue experiencing issues, please let us know on our{' '}
            <a
              href="https://discord.gg/VGmzFfjDSH"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:underline"
            >
              Discord server
            </a>
          </p>

          {error?.digest && (
            <p className="font-mono text-xs text-gray-500">
              Error ID: {error.digest}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
